/** Get the error message from an Error object, or the value itself from a value */
export function errorMessage(error: unknown): unknown {
    return error instanceof Error ? error.message : error;
}
